/**
 * The auth flow's full-page navigations, in one place.
 *
 * NOT every `window.location.href =` in the dashboard — several other
 * surfaces still write it directly. This is the seam the sign-in and
 * post-callback hops go through.
 *
 * WHY A SEAM. `window.location.href = …` is a real browser navigation and
 * cannot be observed in a test: under jsdom 26 `window.location` is
 * `[Unforgeable]` (non-configurable, and `assign` is read-only), so it can
 * neither be replaced nor spied, and jsdom refuses the navigation without
 * recording the target. Routing every deliberate full-page hop through
 * this function is what lets `lib/auth/__tests__/login-provider.test.tsx`
 * prove that sign-in goes to `GET /api/auth/login` and never to a
 * provider's authorize URL built in the browser (Phase 3B Task 7).
 *
 * This is for FULL-PAGE hops only — in-app navigation stays on
 * `next/navigation`'s router, which preserves React state. Callers:
 * `lib/auth/provider.tsx` (`login`, `logout`) and
 * `app/(auth)/auth/callback/page.tsx` (the post-login landing).
 */
export function navigateTo(url: string): void {
  if (typeof window === 'undefined') return;
  window.location.href = url;
}
